import { render, staticRenderFns } from "./sku-list-dialog.vue?vue&type=template&id=99a50f2c&scoped=true"
import script from "./sku-list-dialog.vue?vue&type=script&lang=ts"
export * from "./sku-list-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a50f2c",
  null
  
)

export default component.exports